"use client";

import KundaliChart from "@/components/KundaliChart";

const SUBTITLE = {
  en: "North Indian chart · select a graha for details",
  hi: "उत्तर भारतीय चार्ट · विवरण के लिए ग्रह चुनें",
} as const;

/**
 * Draws a divisional chart with the same North/South renderer the free kundali
 * uses. Visual only: it places the engine's varga sign and house for each graha
 * and marks the varga lagna; it adds no reading of its own. A graha's
 * `is_retrograde`, when the caller's engine gives one, reaches both charts.
 * `unflaggedDignity="unknown"` keeps the selected graha's detail from calling
 * a graha of no computed dignity "Standard dignity" (KundaliChart); the varga
 * pages leave it unset, as before.
 */
export default function VargaChartDiagram({
  title,
  lagnaSign,
  planets,
  locale = "en",
  unflaggedDignity,
}: {
  title: string;
  lagnaSign: string;
  planets: readonly { planet_id: string; sign: string; house: number; is_retrograde?: boolean }[];
  locale?: "en" | "hi";
  unflaggedDignity?: "standard" | "unknown";
}) {
  return (
    <section className="rounded-xl border border-border-default bg-surface-raised p-4">
      <KundaliChart
        planets={planets.map(({ planet_id, sign, house, is_retrograde }) => ({
          planet_id,
          rashi: sign,
          house,
          ...(is_retrograde !== undefined && { is_retrograde }),
        }))}
        houses={[{ house_number: 1, sign: lagnaSign }]}
        locale={locale}
        title={title}
        subtitle={SUBTITLE[locale]}
        unflaggedDignity={unflaggedDignity}
      />
    </section>
  );
}
